// Source: app/scripts/services/date-parse.js
Auction.factory('dateParse', ['settings', function(settings) {
  function minYear() {
    return settings.dateMinYear || 1900;
  }

  function maxYear() {
    return settings.dateMaxYear || 2100;
  }

  function yearInRange(year) {
    return year >= minYear() && year <= maxYear();
  }

  function typedFourDigitYear(str) {
    var dmy = str.match(/^(\d{1,2})[.\-\/](\d{1,2})[.\-\/](\d{4})(?:\s|$)/);
    if (dmy) {
      return parseInt(dmy[3], 10);
    }
    var ymd = str.match(/^(\d{4})[.\-\/](\d{1,2})[.\-\/](\d{1,2})/);
    if (ymd) {
      return parseInt(ymd[1], 10);
    }
    return null;
  }

  function parse(str) {
    if (str instanceof Date) {
      if (isNaN(str.getTime()) || !yearInRange(str.getFullYear())) {
        return null;
      }
      return str;
    }
    if (str == null) {
      return null;
    }
    str = String(str).trim();
    if (!str) {
      return null;
    }
    var typedYear = typedFourDigitYear(str);
    if (typedYear != null && !yearInRange(typedYear)) {
      return null;
    }
    var formats = (settings.dateParseFormats || []).concat(settings.dateFormats || []);
    var parsed = moment(str, formats, true);
    if (!parsed.isValid()) {
      parsed = moment(str, moment.ISO_8601, true);
    }
    if (!parsed.isValid()) {
      parsed = moment(str, formats);
    }
    if (!parsed.isValid() || !yearInRange(parsed.year())) {
      return null;
    }
    return parsed.toDate();
  }

  return {
    parse: parse
  };
}]);
